import _upperFirst from 'lodash/upperFirst';

import { getTranslation } from 'helpers/getTranslation';

export const getCourseStatusVariant = (progress: any, startedAt: any) => {
  if (progress === 100) {
    return 'success';
  }

  if (progress > 0) {
    return 'info';
  }

  if (progress === 0 && startedAt) {
    return 'info';
  }

  return 'default';
};

export const getCourseStatusText = ({
  progress,
  startedAt,
  completedLessons,
  lessonsCount,
}: {
  progress: any;
  startedAt: any;
  completedLessons: any;
  lessonsCount: any;
}) => {
  if (progress === 100) {
    return getTranslation('student_page.courses_section.status_text.completed');
  }

  if (progress > 0) {
    return getTranslation(
      'student_page.courses_section.status_text.in_progress',
      { completedLessons, lessonsCount },
    );
  }

  if (progress === 0 && startedAt) {
    return getTranslation(
      'student_page.courses_section.status_text.in_progress',
      { completedLessons, lessonsCount },
    );
  }

  return getTranslation('student_page.courses_section.status_text.not_started');
};

/** Rows that can show the per-course certificate action (root admin). */
export const showCertificateIssueAction = (course: {
  withCertificate?: boolean;
}) => course.withCertificate === true;

export const isCourseFullyCompleted = (course: {
  progress?: number;
  completed?: boolean;
}) => course.progress === 100 || course.completed === true;

export const getCourseType = (type: any = '-') => {
  if (!type || type === '-') {
    return '-';
  }

  return String(type)
    .split('_')
    .map((word) => _upperFirst(word.toLowerCase()))
    .join(' ');
};
